import script from "./UserNewForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserNewForm.vue?vue&type=script&setup=true&lang=ts"

import "./UserNewForm.vue?vue&type=style&index=0&id=7d5a9834&lang=css"

const __exports__ = script;

export default __exports__